import createVueApp from '@/common/createApp'

Styxie.Initializers.Downloads = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/downloads/show/index.vue')
    createVueApp(ShowPage, { props, layout: null })
  }
}
